<template>
  <div class="row row-cols-auto justify-content-between mb-2 mx-auto gap-2">
    <div class="col-auto p-0 d-inline-flex">
      <h5 class="my-auto">Rombongan Belajar</h5>
    </div>
    <div class="col-auto p-0 ms-auto">
      <select class="form-select form-select-sm shadow-sm" v-model="semester">
        <option disabled value="">-- Pilih Semester --</option>
        <option v-for="s in listSemester" :key="s" :value="s">{{ s.nama }}</option>
      </select>
    </div>
  </div>
  <div v-if="rombelKontrol.length" class="accordion shadow rounded-bottom">
    <div class="accordion-item" v-for="d, index in rombelKontrol" :key="d">
      <h6 class="accordion-header">
        <button class="accordion-button collapsed py-2" type="button" data-bs-toggle="collapse"
          :data-bs-target="'#r' + d.rombel_id" aria-expanded="false" :aria-controls="d.rombel_id">
          <div class="row justify-content-between w-100 gap-3">
            <div class="col-3">{{ d.nama }}</div>
            <div class="col">
              <div class="progress h-100 text-bg-secondary" role="progressbar" :aria-valuenow="d.jumlah_jadwal"
                aria-valuemin="0" :aria-valuemax="d.total_jam">
                <div class="progress-bar progress-bar-striped progress-bar-animated overflow-visible px-1" :class="[d.jumlah_jadwal == d.total_jam ? 'text-bg-success' :
                                  d.jumlah_jadwal / d.total_jam > 0.75 ? 'text-bg-info' :
                                    d.jumlah_jadwal / d.total_jam > 0.5 ? 'text-bg-warning' :
                                      d.jumlah_jadwal / d.total_jam > 0 ? 'text-bg-danger' : 'text-bg-secondary'
                                ]" :style="{ width: memuat ? '0%' : d.jumlah_jadwal / d.total_jam * 100 + '%' }">
                  {{ d.jumlah_jadwal || 0 }}/{{ d.total_jam }}
                </div>
              </div>
            </div>
          </div>
        </button>
      </h6>
      <div :id="'r' + d.rombel_id" class="accordion-collapse collapse">
        <div class="accordion-body bg-light x-5" :class="{ 'rounded-bottom': index == rombelKontrol.length - 1 }">
          <div class="accordion shadow-sm">
            <div class="accordion-item">
              <h6 class="accordion-header">
                <button class="accordion-button collapsed py-1" type="button" data-bs-toggle="collapse"
                  :data-bs-target="'#r' + d.rombel_id + '-hari'" aria-expanded="false"
                  :aria-controls="d.rombel_id + '-hari'" @click="d.dataHari ? '' : getHariKontrol(d)">
                  Hari
                </button>
              </h6>
              <div :id="'r' + d.rombel_id + '-hari'" class="accordion-collapse collapse">
                <div class="accordion-body">
                  <div v-if="!d.dataHari" class="spinner-border text-info text-center" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <table v-else class="table table-sm table-striped table-hover shadow mb-0">
                    <thead class="table-secondary align-middle">
                      <tr>
                        <th>Hari</th>
                        <th>Jumlah Jam Terjadwal/Jumlah Jam per Hari</th>
                      </tr>
                    </thead>
                    <tbody class="small">
                      <tr v-for="h in d.dataHari" :key="h">
                        <td>{{ h.nama }}</td>
                        <td>{{ h.jumlah_jadwal || '-' }}/{{ h.jumlah_jam }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h6 class="accordion-header">
                <button class="accordion-button collapsed py-1" type="button" data-bs-toggle="collapse"
                  :data-bs-target="'#r' + d.rombel_id + '-mapel'" aria-expanded="false"
                  :aria-controls="d.rombel_id + '-mapel'" @click="d.dataMapel ? '' : getMapelKontrol(d)">
                  Mata Pelajaran
                </button>
              </h6>
              <div :id="'r' + d.rombel_id + '-mapel'" class="accordion-collapse collapse">
                <div class="accordion-body">
                  <div v-if="!d.dataMapel" class="spinner-border text-info text-center" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <table v-else class="table table-sm table-striped table-hover shadow mb-0">
                    <thead class="table-secondary align-middle">
                      <tr>
                        <th>Mata Pelajaran</th>
                        <th>Jumlah Jam Terjadwal/Jumlah Jam per Mapel</th>
                      </tr>
                    </thead>
                    <tbody class="small">
                      <tr v-for="m in d.dataMapel" :key="m">
                        <td>{{ m.nama }}</td>
                        <td>{{ m.jumlah_jam_terjadwal || '-' }}/{{ m.jumlah_jam }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h6 class="accordion-header">
                <button class="accordion-button collapsed py-1" type="button" data-bs-toggle="collapse"
                  :data-bs-target="'#r' + d.rombel_id + '-guru'" aria-expanded="false"
                  :aria-controls="d.rombel_id + '-guru'" @click="d.guruPengampu ? '' : getGuruPengampu(d)">
                  Guru Pengampu
                </button>
              </h6>
              <div :id="'r' + d.rombel_id + '-guru'" class="accordion-collapse collapse">
                <div class="accordion-body">
                  <div v-if="!d.guruPengampu" class="spinner-border text-info text-center" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <table v-else class="table table-sm table-striped table-hover shadow mb-0">
                    <thead class="table-secondary align-middle">
                      <tr>
                        <th>Guru Pengampu</th>
                        <th>Mata Pelajaran</th>
                        <th>Jumlah Jam</th>
                      </tr>
                    </thead>
                    <tbody class="small">
                      <tr v-for="g in d.guruPengampu" :key="g">
                        <td>{{ g.nama }}</td>
                        <td>{{ g.nama_mapel }}</td>
                        <td>{{ g.jumlah }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="bg-light py-5">
    <h4 class="text-muted m-0 text-center">Data tidak ditemukan.</h4>
  </div>
  <span v-if="rombelKontrol.length" class="small text-muted fst-italic">
    Menampilkan {{ pageOffset + 1 }}-{{ pageOffset + rombelKontrol.length }} dari total {{ count }} data
  </span>
  <div v-if="rombelKontrol.length" class="row row-cols-auto justify-content-sm-between justify-content-center mt-2">
    <div class="row row-cols-auto">
      <label class="col-auto col-form-label-sm pe-1" for="numRows">Tampilkan:</label>
      <div class="col-auto ps-1">
        <select class="form-select form-select-sm shadow" v-model="pageLimit" id="numRows">
          <option v-for="l in arrayLimit" :key="l" :value="l">
            {{ l }} baris
          </option>
        </select>
      </div>
    </div>
    <div class="col-auto">
      <ul class="pagination pagination-sm shadow mb-0">
        <li class="page-item">
          <button class="page-link" :class="{ disabled: pageCurrent == 1 }"
            @click="pageCurrent > 1 ? pageCurrent-- : ''">&laquo;</button>
        </li>
        <li class="page-item" v-for="p in  pageCount " :key="p">
          <button v-if="p == pageCurrent" class="page-link active fw-bold">{{ p }}</button>
          <button v-else-if="p == 1 || p == pageCount || Math.abs(p - pageCurrent) == 1" class="page-link"
            @click="pageCurrent = p">{{ p }}</button>
          <button v-else-if="(Math.abs(pageCurrent - 1) < 4 && Math.abs(p - 1) < 5) ||
                      (Math.abs(pageCurrent - pageCount) < 4 && Math.abs(p - pageCount) < 5)" class="page-link"
            @click="pageCurrent = p">{{ p }}</button>
          <button
            v-else-if="(Math.abs(p - 1) == 5 || Math.abs(p - pageCount) == 5) && (Math.abs(p - pageCount) == 1 || Math.abs(p - 1) == 1)"
            class="page-link" @click="pageCurrent = p">{{ p }}</button>
          <button v-else-if="Math.abs(p - pageCurrent) == 2 ||
                      (Math.abs(pageCurrent - 1) < 4 && Math.abs(p - 1) == 5) ||
                      (Math.abs(pageCurrent - pageCount) < 4 && Math.abs(p - pageCount) == 5)" class="page-link px-1"
            @click="pageCurrent = p">...</button>
        </li>
        <li class="page-item">
          <button class="page-link" :class="{ disabled: pageCurrent == pageCount }"
            @click="pageCurrent < pageCount ? pageCurrent++ : ''">&raquo;</button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import WebSocketService from './WebSocketService';
export default {
  name: 'KontrolRombel',
  data() {
    return {
      dataListener: (d) => {
        if (d == 'hari' || d == 'statusHari') {
          this.getRombelKontrolUpdate();
          for (const r of this.rombelKontrol) {
            if (r.dataHari) {
              this.getHariKontrol(r);
            }
          }
        }
      },
      penjadwalanListener: (d) => {
        const data = JSON.parse(d);
        if (data.semester_id == this.semester.semester_id) {
          const rombel_id = data.rombel_id || data.new_rombel_id || data.old_rombel_id;
          const i = this.rombelKontrol.findIndex((r) => r.rombel_id == rombel_id);
          if (i >= 0) {
            this.getRombelKontrolUpdate();
            if (this.rombelKontrol[i].dataHari)
              this.getHariKontrol(this.rombelKontrol[i]);
            if (this.rombelKontrol[i].dataMapel)
              this.getMapelKontrol(this.rombelKontrol[i]);
            if (this.rombelKontrol[i].guruPengampu)
              this.getGuruPengampu(this.rombelKontrol[i]);
          }
        }
      },
      rombelKontrol: [],
      listSemester: [],
      semester: "",
      arrayLimit: [10, 25, 50, 100, 250],
      count: 0,
      pageCurrent: 1,
      pageOffset: 0,
      pageLimit: 10,
      pageCount: 0,
      memuat: true,
    }
  },
  mounted() {
    WebSocketService.on("inserted-or-deleted-data", this.dataListener);
    WebSocketService.on("update-data", this.dataListener);
    WebSocketService.on("inserted-or-deleted-jadwal", this.penjadwalanListener);
    WebSocketService.on("update-jadwal", this.penjadwalanListener);
    this.pageLimit = this.batasBaris;
    this.semester = {
      tahun_ajaran_id: this.tpAktif.tahun_ajaran_id,
      ...this.semesterAktif
    };
    this.getListSemester();
  },
  beforeUnmount() {
    WebSocketService.off("inserted-or-deleted-data", this.dataListener);
    WebSocketService.off("update-data", this.dataListener);
    WebSocketService.off("inserted-or-deleted-jadwal", this.penjadwalanListener);
    WebSocketService.off("update-jadwal", this.penjadwalanListener);
  },
  computed: {
    tpAktif() {
      return this.$store.getters.getTp
    },
    semesterAktif() {
      return this.$store.getters.getSemester
    },
    batasBaris() {
      return this.$store.getters.getDefaultLimit
    },
  },
  watch: {
    semesterAktif() {
      this.semester = {
        tahun_ajaran_id: this.tpAktif.tahun_ajaran_id,
        ...this.semesterAktif
      };
    },
    semester() {
      if (this.pageCurrent == 1) {
        this.memuat = true;
        this.getRombelKontrol();
      } else {
        this.pageCurrent = 1;
      }
    },
    pageCurrent() {
      this.pageOffset = (this.pageCurrent - 1) * this.pageLimit;
      this.memuat = true;
      this.getRombelKontrol();
    },
    pageLimit() {
      if (this.pageCurrent == 1) {
        this.memuat = true;
        this.getRombelKontrol();
      } else {
        this.pageCurrent = 1;
      }
    },
  },
  methods: {
    async getListSemester() {
      const headers = {
        Authorization: localStorage.getItem('token')
      };
      try {
        const response = await this.axios.post('/penjadwalan/semester/list', {}, {
          headers: headers
        });
        if (response.data) {
          this.listSemester = response.data.semester;
        }
      }
      catch (err) {
        if (err.response) {
          if (err.response.status == 401) {
            this.$swal({
              title: 'Gagal',
              text: 'Sesi berakhir. Silahkan login ulang.',
              icon: 'error',
              confirmButtonText: 'Baik'
            }).then(() => {
              this.$router.go();
            });
          } else {
            console.log(err);
          }
        } else {
          console.log(err)
        }
      }
    },
    async getRombelKontrol() {
      const headers = {
        Authorization: localStorage.getItem('token')
      };
      try {
        const response = await this.axios.post('/rombel/kontrol', {
          semester_id: this.semester.semester_id,
          limit: this.pageLimit,
          offset: this.pageOffset,
        }, {
          headers: headers
        });
        if (response.data) {
          this.rombelKontrol = response.data.rombel;
          this.count = response.data.count;
          this.pageCount = Math.ceil(this.count / this.pageLimit);
        }
      }
      catch (err) {
        if (err.response) {
          if (err.response.status == 401) {
            this.$swal({
              title: 'Gagal',
              text: 'Sesi berakhir. Silahkan login ulang.',
              icon: 'error',
              confirmButtonText: 'Baik'
            }).then(() => {
              this.$router.go();
            });
          } else {
            console.log(err);
          }
        } else {
          console.log(err)
        }
      }
      setTimeout(() => {
        this.memuat = false;
      }, 250)
    },
    async getRombelKontrolUpdate() {
      const headers = {
        Authorization: localStorage.getItem('token')
      };
      try {
        const response = await this.axios.post('/rombel/kontrol', {
          semester_id: this.semester.semester_id,
          limit: this.pageLimit,
          offset: this.pageOffset,
        }, {
          headers: headers
        });
        if (response.data) {
          const dataRombelKontrol = response.data.rombel;
          for (let i in dataRombelKontrol) {
            this.rombelKontrol[i].jumlah_jadwal = dataRombelKontrol[i].jumlah_jadwal;
            this.rombelKontrol[i].total_jam = dataRombelKontrol[i].total_jam;
          }
        }
      }
      catch (err) {
        if (err.response) {
          if (err.response.status == 401) {
            this.$swal({
              title: 'Gagal',
              text: 'Sesi berakhir. Silahkan login ulang.',
              icon: 'error',
              confirmButtonText: 'Baik'
            }).then(() => {
              this.$router.go();
            });
          } else {
            console.log(err);
          }
        } else {
          console.log(err)
        }
      }
    },
    async getHariKontrol(d) {
      const headers = {
        Authorization: localStorage.getItem('token')
      };
      try {
        const response = await this.axios.post('/hari/kontrol', {
          semester_id: this.semester.semester_id,
          rombel_id: d.rombel_id
        }, {
          headers: headers
        });
        if (response.data) {
          setTimeout(() => {
            d.dataHari = response.data.hari;
          }, 250)
        }
      }
      catch (err) {
        if (err.response) {
          if (err.response.status == 401) {
            this.$swal({
              title: 'Gagal',
              text: 'Sesi berakhir. Silahkan login ulang.',
              icon: 'error',
              confirmButtonText: 'Baik'
            }).then(() => {
              this.$router.go();
            });
          } else {
            console.log(err);
          }
        } else {
          console.log(err)
        }
      }
    },
    async getMapelKontrol(d) {
      const headers = {
        Authorization: localStorage.getItem('token')
      };
      try {
        const response = await this.axios.post('/mapel/kontrol', {
          tahun_ajaran_id: this.semester.tahun_ajaran_id,
          semester_id: this.semester.semester_id,
          rombel_id: d.rombel_id
        }, {
          headers: headers
        });
        if (response.data) {
          setTimeout(() => {
            d.dataMapel = response.data.mapel;
          }, 250)
        }
      }
      catch (err) {
        if (err.response) {
          if (err.response.status == 401) {
            this.$swal({
              title: 'Gagal',
              text: 'Sesi berakhir. Silahkan login ulang.',
              icon: 'error',
              confirmButtonText: 'Baik'
            }).then(() => {
              this.$router.go();
            });
          } else {
            console.log(err);
          }
        } else {
          console.log(err)
        }
      }
    },
    async getGuruPengampu(d) {
      const headers = {
        Authorization: localStorage.getItem('token')
      };
      try {
        const response = await this.axios.post('/rombel/guru-pengampu', {
          semester_id: this.semester.semester_id,
          rombel_id: d.rombel_id
        }, {
          headers: headers
        });
        if (response.data) {
          setTimeout(() => {
            d.guruPengampu = response.data.guru;
          }, 250)
        }
      }
      catch (err) {
        if (err.response) {
          if (err.response.status == 401) {
            this.$swal({
              title: 'Gagal',
              text: 'Sesi berakhir. Silahkan login ulang.',
              icon: 'error',
              confirmButtonText: 'Baik'
            }).then(() => {
              this.$router.go();
            });
          } else {
            console.log(err);
          }
        } else {
          console.log(err)
        }
      }
    },
  },
}
</script>

<style></style>